import { LENTA_COM_DOMAIN } from '@lentau/ui-kit/core/constants/domains';

export const addSlashToBasePath: (url: string) => string = (url: string): string => {
  const tempDomain: string = `https://${LENTA_COM_DOMAIN}`;
  const urlObj: URL = new URL(url, tempDomain);
  const { pathname }: URL = urlObj;

  if (!pathname.endsWith('/')) {
    urlObj.pathname = pathname + '/';
  }

  return urlObj.toString().replace(tempDomain, '');
};
